import { render, staticRenderFns } from "./Appeal.vue?vue&type=template&id=357a9f0a"
import script from "./Appeal.vue?vue&type=script&lang=js"
export * from "./Appeal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports